import React from "react";
import Page from "@components/Layout/page";
import { useCompanyByName } from "@hooks/useCompany";
import { useRouter } from "next/router";
import TryFreeFooter from "@components/TryFreeFooter/TryFreeFooter";
import CompanyDetailsPage from "@components/Pages/CompanyDetailsPage/CompanyDetailsPage";
import { Leaf } from "@components/Leaf/Leaf";
import { useTranslations } from "next-intl";
import LaufidLoader from "@components/LaufidLoader/LaufidLoader";
import styles from "@components/CustomersPage/CustomersPage.module.scss";

export default function Item(item) {
    const t = useTranslations("CustomersPage");
    const router = useRouter();
    const { data: company, error } = useCompanyByName(router.query.infoID);

    if (error?.data?.code === 404) {
        router.push("/404");
    }

    if (!company && !error) {
        return <LaufidLoader />;
    }

    return (
        <div style={{ overflowX: "hidden" }}>
            <Page
                fluid
                bodyClassName={styles.pageBody}
                headTitle={item.name}
                headImageUrl={item.cover_photo}
                headDescription={item.description}
                headUrl={`https://laufid.is/vidskiptavinir/${item.name}`}
                showsFooter={false}
            >
                <div className={styles.bgContainer}>
                    <Leaf className={styles.leaf1} plain />
                    <Leaf className={styles.leaf2} plain />
                    <Leaf className={styles.leaf3} plain />
                    <div className={styles.topGradient} />
                    <div className={styles.pageWrapper}>
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                width: "100%",
                            }}
                        >
                            {company?.results && (
                                <CompanyDetailsPage company={company.results} />
                            )}
                        </div>
                    </div>
                    <TryFreeFooter
                        title={t("would_you_like_participate_road_trip")}
                        subtitle={t("cta_subtitle")}
                        buttonText={t("cta_button")}
                    />
                </div>
            </Page>
        </div>
    );
}

export async function getServerSideProps(context) {
    const { locale } = context;

    let messages;
    try {
        messages = (await import(`../../locales/${locale}.json`)).default;
    } catch (error) {
        console.error(`Could not load messages for locale ${locale}:`, error);
        messages = {};
    }

    return {
        props: {
            messages: messages,
        },
    };
}
